import FarloUiRevolverCarousel from './farlo-ui-revolver-carousel.js';

class FarloUiLightbox {
    constructor(element, options = {}) {
        this.element = element;
        this.options = options;

        this.carouselEnabled = this.checkCarouselEnabled();
        this.currentCarouselIndex = 0;

        if (this.carouselEnabled) {
            this.carouselItems = Array.from(this.element.children);
            this.carouselItems.forEach((item, index) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.currentCarouselIndex = index;
                    this.openLightbox();
                });
            });
        } else {
            this.element.addEventListener('click', (event) => {
                event.preventDefault();
                this.openLightbox();
            });
        }

        // Ensure lightbox elements exist before assigning them
        this.initialiseLightboxContainer();

        this.lightbox = document.querySelector('.farlo-ui-lightbox');
        this.lightboxContentInner = this.lightbox.querySelector('.farlo-ui-lightbox__content-inner'); // Now correctly selecting content
        this.closeButton = this.lightbox.querySelector('.farlo-ui-lightbox__close');
        this.backdrop = this.lightbox.querySelector('.farlo-ui-lightbox__backdrop');

        this.element.addEventListener('click', this.openLightbox.bind(this));
        this.closeButton.addEventListener('click', this.closeLightbox.bind(this));
        this.backdrop.addEventListener('click', this.closeLightbox.bind(this));

        // Close the lightbox when clicking outside `.farlo-ui-lightbox__content-inner`
        this.lightbox.addEventListener('click', (event) => {
            if (!this.lightboxContentInner.contains(event.target)) {
                this.closeLightbox();
            }
        });

        this.lightbox.addEventListener('keydown', this.handleKeydown.bind(this));
        this.element.setAttribute('aria-haspopup', 'dialog');
        this.lightbox.setAttribute('role', 'dialog');
        this.lightbox.setAttribute('aria-modal', 'true');
        this.closeButton.setAttribute('aria-label', 'Close Lightbox');
    }

    checkCarouselEnabled() {
        const parentElement = this.element.closest('.farlo-ui-revolver-carousel--enabled');
        return parentElement ? true : false;
    }

    initialiseLightboxContainer() {
        if (!document.querySelector('.farlo-ui-lightbox')) {
            const div = document.createElement('div');
            const divInner = document.createElement('div');
            const divInnerContent = document.createElement('div');
            const divClose = document.createElement('button');
            const divBackdrop = document.createElement('div');

            div.className = 'farlo-ui-lightbox';
            divInner.className = 'farlo-ui-lightbox__inner';
            divInnerContent.className = 'farlo-ui-lightbox__content-inner';
            divClose.className = 'farlo-ui-lightbox__close';
            divBackdrop.className = 'farlo-ui-lightbox__backdrop';

            div.appendChild(divInner);
            divInner.appendChild(divInnerContent);
            divInner.appendChild(divClose);
            div.appendChild(divBackdrop);
            document.body.appendChild(div);
        }
    }

    openLightbox() {
        const content = this.generateGalleryContent(this.carouselEnabled ? this.element : this.element.parentNode, this.options.carousel);
        this.lightboxContentInner.innerHTML = content;

        if (this.options.carousel && this.carouselEnabled) {
            const carouselElement = this.lightboxContentInner.querySelector('.farlo-ui-revolver-carousel');
            if (carouselElement) {
                this.carousel = new FarloUiRevolverCarousel(carouselElement, { initialIndex: this.currentGalleryIndex });
            }
        }

        this.lightbox.classList.add('farlo-ui-lightbox--active');
        this.lightbox.focus();
    }

    closeLightbox() {
        
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;
        
        this.lightbox.classList.remove('farlo-ui-lightbox--active');
    
        setTimeout(() => {
            if (!this.element.nextElementSibling && typeof this.element.nextElementSibling.childNodes === 'undefined' && !this.element.nextElementSibling.classList.contains('farlo-ui-lightbox')) {
                this.lightboxContentInner.innerHTML = '';
            }
            this.element.focus();
    
            window.scrollTo(scrollX, scrollY);
        }, 300);
    }
    

    handleKeydown(event) {
        if (event.key === 'Escape') {
            this.closeLightbox();
        }
    }

    generateGalleryContent(element, isCarousel) {
        let content = '';

        if (isCarousel) {
            content += '<div class="farlo-ui-revolver-carousel">';
            Array.from(element.children).forEach((item, index) => {
                content += `
                    <div class="farlo-ui-revolver-carousel__chamber">
                        ${ item.innerHTML }
                    </div>
                `;
            });
            content += '</div>';
        } else {
            content += element.innerHTML;
        }

        return content;
    }
}

export default FarloUiLightbox;
